
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "updateScenario",
      resolverType: "mutation",
      routePath: "/updateScenario",
      httpMethod: "POST",
    });
  